<div class="guest-landing-page">
    <vs-quick-tracking-widget></vs-quick-tracking-widget>
    <vs-product-lines></vs-product-lines>
    <vs-register-section></vs-register-section>
    <vs-featured-product-section></vs-featured-product-section>
    <vs-contact-us-section></vs-contact-us-section>
</div>